import { render, staticRenderFns } from "./review-card-stub.vue?vue&type=template&id=3d6d0cf4"
import script from "./review-card-stub.vue?vue&type=script&lang=ts"
export * from "./review-card-stub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports